import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  LISTING_DATA_SOURCE_SUNROOM,
  LISTING_OCCUPANT_TYPE_VACANT,
} from 'common/listingConstants';

class SrAdminTourNotes extends Component {
  static propTypes = {
    showing: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
    onOpenShowingNotes: PropTypes.func,
  };

  static defaultProps = {
    onOpenShowingNotes: () => {},
  };

  render() {
    const { showing, listing, onOpenShowingNotes } = this.props;
    const isVacantOverride = listing.occupantType === LISTING_OCCUPANT_TYPE_VACANT &&
      Object.keys(listing.overrides || {}).includes('occupantType');

    return (
      <td className='notes'>
        <span className='tooltip under'>
          {isVacantOverride && (
            <span className='text'>Vacant Override<br /></span>
          )}
          {showing.isOccupantConfirmed !== null && (
            <span className='text'>
              {showing.isOccupantConfirmed === true ? 'Confirmed' : 'Pending'} Occupant
              <br />
            </span>
          )}
          {showing.isAgentConfirmed !== null && (
            <span className='text'>
              {showing.isAgentConfirmed === true ? 'Confirmed' : 'Pending'} Agent
              <br />
            </span>
          )}
          {listing.lockboxCode && (
            <span className='text'>
              <br />
              {`Combo code:  ${listing.lockboxCode}`}
              <br />
            </span>
          )}
          {listing.notesForShowing && (
            <span className='text'>
              <br />
              {listing.notesForShowing}
            </span>
          )}
        </span>
        <div className='actionsRow' onClick={() => onOpenShowingNotes(listing.id)}>
          {
            listing.dataSource === LISTING_DATA_SOURCE_SUNROOM
            && listing.showingInstructions
            && (
              <span className='floatingLabel'>special</span>
            )
          }
          {
            (
              (showing.isOccupantConfirmed === false || showing.isAgentConfirmed === false) ||
              (showing.isOccupantConfirmed === null && showing.isAgentConfirmed === null) && !isVacantOverride
            ) ? 'Pending' : 'Confirmed'
          }
          {listing.lockboxCode ? ', Combo' : ''}
        </div>
      </td>
    );
  }
}

SrAdminTourNotes.displayName = 'SrAdminTourNotes';

export default SrAdminTourNotes;
